module.exports = __webpack_public_path__ + "img/mag (6).1452e398.png";